<ng-container *ngIf="costAccountingTypeState$ | async as state">
    <div class="cost-accounting-type-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <button mat-mini-fab
                    color="primary"
                    matTooltip="{{ 'app.page.cost-accounting-type.actions.add.label' | translate }}"
                    (click)="onOpenDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource">


                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-accounting-type.name.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <ng-container matColumnDef="material-price">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-accounting-type.materialPrice.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ "app.model.cost-accounting-type.materialPrice."+ element.materialPrice + ".label" | translate }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="material-quantity">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-accounting-type.materialQuantity.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ "app.model.cost-accounting-type.materialQuantity."+ element.materialQuantity + ".label" | translate }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="production-time">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-accounting-type.productionTime.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ "app.model.cost-accounting-type.productionTime."+ element.productionTime + ".label" | translate }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="sales-price">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-accounting-type.salesPrice.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ "app.model.cost-accounting-type.salesPrice."+ element.salesPrice + ".label" | translate }}
                    </td>
                </ng-container>


                <ng-container matColumnDef="delete-button">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.cost-accounting-type.actions.delete.label' | translate }}"
                                (click)="onDeleteCostAccountingType(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="sales-volume">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-accounting-type.salesVolume.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ "app.model.cost-accounting-type.salesVolume."+ element.salesVolume + ".label" | translate }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="state.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.columns;"></tr>

                <mat-paginator [pageSizeOptions]="[20, 50]"
                               showFirstLastButtons>
                </mat-paginator>

            </table>
        </div>
    </div>
</ng-container>
